import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Showcase from '../components/Showcase';
import Rankings from '../components/Rankings';
import Download from '../components/Download';
import Footer from '../components/Footer';

const HomePage: React.FC = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <Showcase />
      <Rankings />
      <Download />
      <Footer />
    </>
  );
};

export default HomePage;
